import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "@core/services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = this.headers;
    request = request.clone({
      setHeaders: headers,
    })
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if(err.status === 401 || err.status === 403) {
          this.toastr.error('Si è verificato un problema, si prega di rieffettuare il login','Errore di autenticazione')
          this.authService.redirectToLogin();
        }
        return throwError(() => err)
      })
    );
  }

  private get headers(): any{
    const jwt = localStorage.getItem('jwt');
    if(jwt){
      return {
        Authorization: `Bearer ${jwt}`
      }
    } else {
      return {}
    }
  }

}
